module.exports = __webpack_public_path__ + "static/media/bellOn-icon.157303da.svg";